import { Carrier } from '@/model';

/**
 * Produces a label appropriate for a carrier in a select or multi-select.
 */
export const carrierLabel = (carrier?: Carrier): string => {
  if (!carrier) {
    return '';
  }

  if (!carrier.name) {
    return carrier.scac ?? '';
  }

  return carrier.scac ? `${carrier.name} (${carrier.scac})` : carrier.name;
};
